// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tableBox {
  /*    border: 1px solid #E41B47;*/
  border: 1px solid #00C1D4;
  border-radius: 5px;
  padding: 1px 5px;
  cursor: pointer;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  margin-bottom: 5px;
}

.action-white {
  margin-left: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/custom-dialog/custom-dialog.component.scss"],"names":[],"mappings":"AAAA;EACA,iCAAA;EACI,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yHAAA;EACA,kBAAA;AACJ;;AAEA;EACI,iBAAA;AACJ","sourcesContent":[".tableBox {\n/*    border: 1px solid #E41B47;*/\n    border: 1px solid #00C1D4;\n    border-radius: 5px;\n    padding: 1px 5px;\n    cursor: pointer;\n    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);\n    margin-bottom: 5px;\n}\n\n.action-white{\n    margin-left: 10px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
